import { isEqual } from 'lodash-es';
import React, { useRef, useMemo } from 'react';

/**
 * 深度比较依赖项的 useMemo
 * @param factory 值生成函数
 * @param deps 依赖项数组（进行深比较）
 * @returns 记忆化的值
 */
function useDeepCompareMemo<T>(factory: () => T, deps: React.DependencyList): T {
  const prevDepsRef = useRef<React.DependencyList>(deps);
  const signalRef = useRef<number>(0);

  if (!isEqual(deps, prevDepsRef.current)) {
    prevDepsRef.current = deps;
    signalRef.current += 1;
  }

  return useMemo(factory, [signalRef.current]);
}

export default useDeepCompareMemo;
